// features-page.component.jsx (updated for i18n)
import React from 'react';
import './features-page.styles.scss';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import { Getstarted } from '../../../components/essentials/get-started/getstarted.component';
import autodata from '../../../assest/6 - Solutions - Features/Automated Data Extraction.png';
import facerec from '../../../assest/6 - Solutions - Features/Face Recognition.png';
import global from '../../../assest/6 - Solutions - Features/Global Coverage.png';
import reduced from '../../../assest/6 - Solutions - Features/Reduced Risk, Assured Compliance _ An Enhanced Customer Experience.png';
import swifter from '../../../assest/6 - Solutions - Features/Swifter _ Seamless Authentication.png';
import kysBulletPoint from '../../../assest/2 - Solutions - Platforms/secure-payment.svg';
import photoOnPhone from '../../../assest/6 - Solutions - Features/whatmore.jpg';
//import middle from '../../../assest/6 - Solutions - Features/image (1).png';
//import middle1 from '../../../assest/6 - Solutions - Features/features (1).png';
import { useTranslation } from 'react-i18next';
// Static imports
import features_US from '../../../assest/6 - Solutions - Features/features_US.png';
import features_GB from '../../../assest/6 - Solutions - Features/features_GB.png';

export const FeaturesPage = () => {
  const { t } = useTranslation('features-page');

  const featureImageMap = {
    features_US,
    features_GB,
  };

  const selectedfeatureImageKey = t('featureImageKey'); // From JSON
  const middle1 = featureImageMap[selectedfeatureImageKey] || features_US;

  const sections = t('sections', { returnObjects: true });
  const moreCards = t('moreCards', { returnObjects: true });

  return (
    <div className='solution-platform'>
      <NavBar />
      <HeaderHalf title={t('pageTitle')} uris={t('pageUri')} />

      <SectionLeft class='feature-box-left padding-up' {...sections[0]} imgPath={reduced} />
      <SectionRight {...sections[1]} imgPath={swifter} />
      <SectionLeft class='feature-box-left' {...sections[2]} imgPath={global} />
      <SectionRight {...sections[3]} imgPath={autodata} />
      <SectionLeft class='feature-box-left' {...sections[4]} imgPath={facerec} />

      <div className='features-middle-content1'>
        <img src={middle1} className='features-middle' alt='middle-section' />
      </div>

      <OverlapBoxFeature title={t('moreTitle')}>
        <MoreBox cards={moreCards} />
      </OverlapBoxFeature>

      <Getstarted />
      <Footer />
    </div>
  );
};

const SectionLeft = ({ class: className, title, content, imgPath }) => (
  <div className={className}>
    <p className='title-feature'>{title}</p>
    <div className='display-flex'>
      <div className='feature-box-image'><img src={imgPath} alt={title} /></div>
      <div className='feature-box-content'>{content}</div>
    </div>
  </div>
);

const SectionRight = ({ title, content, imgPath }) => (
  <div className='feature-box-right'>
    <p className='title-feature'>{title}</p>
    <div className='display-flex'>
      <div className='feature-box-content'>{content}</div>
      <div className='feature-box-image'><img src={imgPath} alt={title} /></div>
    </div>
  </div>
);

const HeaderHalf = ({ title, uris }) => (
  <div className='headerHalf-main-features'>
    <div className='headerHalf-content'>
      <p className='headerHalf-title'>{title}</p>
      <p className='headerHalf-uris'>Platform / <span className='uris-class'>{uris}</span></p>
    </div>
  </div>
);

const MoreBox = ({ cards }) => (
  <div className='kys-div'>
    <div className='kys-platform-content'>
      {cards.slice(0, 3).map((card, index) => (
        <MoreCard key={index} icon={kysBulletPoint} {...card} />
      ))}
    </div>
    <div className='kys-platform-content'>
      {cards.slice(3).map((card, index) => (
        <MoreCard key={index + 3} icon={kysBulletPoint} {...card} />
      ))}
    </div>
    <div className='kys-platform-img'>
      <img src={photoOnPhone} className='kys-platform-image' alt='Feature Visual' />
    </div>
  </div>
);

export const MoreCard = ({ icon, title, desc }) => (
  <div className='kys-card'>
    <div className='key-icon-col'>
      <img src={icon} className='kft-card-icon' alt='icon' />
    </div>
    <div className='key-text-col'>
      <p className='kys-card-desc'><strong>{title}: </strong>{desc}</p>
    </div>
  </div>
);

export const OverlapBoxFeature = ({ title, children }) => (
  <div className='overlap-box extend-it whatmore'>
    <p className='box-title'>{title}</p>
    {children}
  </div>
);
